import React from 'react';
import Checkbox from 'components/checkbox';
import BaseHint from 'components/hintTypes/BaseHint';
import { text } from 'components/hintTypes/constants';
import { textHelpers } from 'components/hintTypes/helpers';
import { partnershipMemberContactFormFields } from 'constants/formFields';
import { Intent } from 'constants/ui';
const EmailAssociatedWithOtherCompaniesHint = ({ associatedCompanies = [], className, errors, fieldName = partnershipMemberContactFormFields.META_KNOWN_PARTNERSHIP_IDS, isChecked, onChange, }) => {
    if (!associatedCompanies?.length) {
        return null;
    }
    return (React.createElement(BaseHint, { className: className, content: React.createElement(Checkbox, { className: "mb-4", content: React.createElement("span", { className: "text-[13px]" }, text.emailAssociatedWithOtherCompaniesHint.text), errors: errors, isChecked: isChecked, name: fieldName, onChange: onChange }), contentProps: {
            className: 'mt-4',
        }, intent: Intent.WARNING, multiline: true, title: textHelpers.getEmailAssociatedWithOtherCompaniesHintTitle(associatedCompanies) }));
};
export default EmailAssociatedWithOtherCompaniesHint;
